import { render } from "./footerCom1.vue?vue&type=template&id=5ddb5386&scoped=true"
const script = {}

import "./footerCom1.vue?vue&type=style&index=0&id=5ddb5386&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddb5386"]])

export default __exports__